<template>
  <div class="page">
    <div class="locations-grey locations-generic gift">
      <section>
        <strong>To purchase a gift certificate, e-mail us:</strong> 
      </section >
      <ul>
        <li>The full name, as you want it to appear, of the person to whom you're giving the gift. </li>
        <li>The dollar amount you want to spend.</li>
        <li>Your name as you want it to appear.</li>
      </ul>
We'll send you a payment link. Once you've paid, we will e-mail you the certificate.<br><br>
Email Liam Durnan: <a href="mailto:Info@ChicagoRiverPaddle.com">Info@ChicagoRiverPaddle.com</a> 
  </div>
  </div>
</template>

<script>
export default {
  name: 'Gift',
  props: {
    msg: String
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:hover {
color:#9f001c !important;   
}
a {
color: white;   
}
.gift {
width: 50%;
align-self: center;
}
.fa-circle {
  font-size: 6px;
}
.page {
  background-image: url("../../assets/pic22.jpg");
  flex-direction: column;
  padding-left: 20px;
}
section {
  margin-bottom: 10px;
}
@media screen and (max-width: 768px) {
  .gift {
    width: 90%;
  }
}
</style>
